import React from 'react'
import { Card, CardContent, Grid, Typography, Box, makeStyles } from '@material-ui/core'
import { getValidDate } from 'lib/utils'

const useStyles = makeStyles(() => ({
  scrollBox: {
    overflowY: 'auto',
    maxHeight: 160,
    '&::-webkit-scrollbar': { width: 4 },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0,0.3)',
      borderRadius: 4
    }
  }
}))

const Row = ({ label, value, isLongText = false, classes = {} }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Typography variant="caption" style={{ display: 'block', opacity: 0.7 }}>
      {label}
    </Typography>
    {isLongText ? (
      <Box
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'pre-wrap',
          maxHeight: 160,
          overflowY: 'auto',
          scrollbarColor: 'red',
          scrollbarWidth: 50,
          padding: '4px 6px',
          border: '1px solid #eee',
          borderRadius: 6,
          backgroundColor: '#fafafa'
        }}
        className={classes}
      >
        <Typography variant="body2">{value}</Typography>
      </Box>
    ) : (
      <Typography variant="body1" style={{ wordBreak: 'break-word' }}>
        {value}
      </Typography>
    )}
  </Grid>
)

export const ApplicationInfo = ({ application }) => {
  const wl = application?.workListInfo || {}
  const susp = application?.suspension || {}
  const classess = useStyles()

  const money = v => (v || v === 0 ? `${Number(v).toLocaleString('ru-RU')} ₸` : '-')
  const type = application?.applicationType || '-'

  return (
    <Card variant="outlined" style={{ width: '100%', marginTop: 8 }}>
      <CardContent>
        <Grid container spacing={3}>
          <Row label="Тип заявления" value={type} />
          <Row label="ID рабочего листа" value={application?.workListId || '-'} />
          <Row label="ID контракта" value={application?.contractId || '-'} />
          <Row
            label={
              application?.decisionAt
                ? 'Дата принятие решений'
                : application?.completedAt
                ? 'Дата согласований'
                : 'Дата принятие решений/согласований'
            }
            value={getValidDate(application?.decisionAt || application?.completedAt)}
          />
          <Row label="Номер договора" value={wl?.contractNumber || '-'} />
          <Row label="Клиент" value={wl?.clientFullName || '-'} />
          <Row label="ИИН" value={wl?.clientIin || '-'} />
          <Row label="Продукт" value={wl?.creditProductName || '-'} />
          <Row label="Дней просрочки" value={wl?.overdueDays ?? '-'} />
          <Row label="Сумма займа" value={money(wl?.loanAmount)} />
          <Row label="Остаток долга" value={money(wl?.overdueTranchesSum)} />
          {application?.type === 'SUSPENSION' && (
            <>
              <Row label="Причина приостановки" value={susp?.reason || '-'} />
              <Row label="Срок с" value={getValidDate(susp?.suspendFrom)} />
              <Row label="Срок до" value={getValidDate(susp?.suspendUntil)} />
              <Row label="Дата уведомления" value={getValidDate(susp?.notificationDate)} />
            </>
          )}
          <Row
            label="Причина отсрочки"
            value={application?.submitReason || application?.commonReason || '-'}
            isLongText
            classes={classess.scrollBox}
          />
        </Grid>
      </CardContent>
    </Card>
  )
}
